import React from 'react'
import PickUpSlots from '../PickupOrderType/PickupMethod/PickupSlots';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../redux/store/store';
import { trackSwitchPickupClick } from '../../../analytics/pulseSwitchOrderTypeClick';

interface IItemDeliveryDateAndTimeProps {
    subTotal?: number;
    tax?: number;
    total?: number;
    closeDeliveryMethodModal?: (boolean) => void,
    editDeliveryType?: (boolean) => void;
    handleChangeOrderType?: boolean;
    isEditSlot? : boolean
  }
const ItemDeliveryDateAndTime = (props: IItemDeliveryDateAndTimeProps) => {
    const {tax, subTotal, total, closeDeliveryMethodModal,  editDeliveryType, handleChangeOrderType, isEditSlot} = props
    const location = useLocation();
    const isCartOpen = useAppSelector((state) => state.cart.showCart);

 
    const handleChangeToPickupModal = () => {
        trackSwitchPickupClick({
          isCartOpen,
          page_path: location.pathname,
        });
        closeDeliveryMethodModal(true)
        editDeliveryType(true)    
     }

    return (
        <div data-testid="slot-select-modal">
            <PickUpSlots 
              subTotal={subTotal} 
              tax={tax} 
              total={total} 
              isEditSlot={isEditSlot} 
              closeDeliveryMethodModal={closeDeliveryMethodModal} 
            />
          {
          !handleChangeOrderType && 
          <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className={`btn btn-custom p-0 f-w6 p-16 color-sky-blue-light font-Vcf mb-5`}
                  onClick= {() => handleChangeToPickupModal()}
                >
                  Change To Pick-Up
                </button>
              </div>
          }
        </div>

    )
}

export default ItemDeliveryDateAndTime